import { Theme } from '@mui/material/styles'
import { menuItemClasses } from '@mui/material/MenuItem'

export const getPositionMenuItemStyles = (theme: Theme) => ({
  root: {
    [`&.${menuItemClasses.disabled}`]: {
      fontWeight: 600,
      color: theme.palette.common.black,
      opacity: '1',
      cursor: 'default',
      pointerEvents: 'none',
    },
  },
})
